import React from 'react';
import FormModal from '../../../components/ui/FormModal/FormModal';
import {
  buildCreateProjectFields,
  cleanProjectValues,
} from './projectFormFields';

/**
 * Create New Project modal — uses the shared FormModal primitive with
 * the 6 base project fields. The Hierarchical Analysis option (analysis
 * mode select + parent-analyses picker and its sessions-for-linking
 * fetch) was removed in production issue #4 (2026-07-10): new projects
 * are always individual analyses. `cleanProjectValues` still pins
 * `analysis_mode`/`parent_sessions` so the backend payload shape is
 * unchanged, and existing hierarchical projects are unaffected.
 */
const CreateProjectModal = ({ onClose, onCreate }) => (
  <FormModal
    title="Create New Project"
    fields={buildCreateProjectFields()}
    submitLabel="Create Project"
    submittingLabel="Creating..."
    maxWidth={560}
    onSubmit={async (values) => {
      await onCreate(cleanProjectValues(values));
    }}
    onClose={onClose}
  />
);

export default CreateProjectModal;
